import { useEffect, useState } from "react";
import { isAndroid, isMobile } from "react-device-detect";
import { MdOutlineClose } from "react-icons/md";

const DownloadApp = () => {

  const [isVisible, setIsVisible] = useState(true);
  const [isWebView, setIsWebView] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isWV = /wv/.test(userAgent.toLowerCase()) || /; wv\)/.test(userAgent);
    setIsWebView(isWV);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/apk/laser.apk"; 
    link.download = "laser.apk"; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  if(window.location.host === "dubaibet.club") return null
  if (!isVisible || !isAndroid || !isMobile || isWebView) return null;

  return (
    <>
      {isVisible && (
        <div id="appdownload" className="w-full bg-black text-white p-2 flex items-center justify-between md:hidden">
          <div className="flex items-center">
            <img src="playstore.webp" alt="" />
            <div>
              <p className="text-[15px] font-bold">Download Android App</p>
              <p className="text-xs">Instant Download on your device</p>
            </div>
          </div>
          <div>
            <button className="App-install" onClick={handleDownload}>Install</button>

            <button className="pl-4" onClick={handleClose}>
              <MdOutlineClose />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DownloadApp;
